<div class="memo-container">
    <div class="header">
        <h2 class="section-title">チームメモ</h2>
        <button mat-flat-button color="primary" (click)="saveMemo()">
            <mat-icon>save</mat-icon> Save
        </button>
    </div>

    <mat-card class="memo-card">
        <mat-form-field appearance="outline" class="memo-field">
            <textarea matInput [(ngModel)]="memoContent" placeholder="チームで共有するメモ..."></textarea>
        </mat-form-field>
    </mat-card>
</div>